import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49f02364"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-container" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "批次ID", -1))
const _hoisted_5 = { class: "box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "所属企业", -1))
const _hoisted_7 = { class: "box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "使用渠道", -1))
const _hoisted_9 = { class: "box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "活动名称", -1))
const _hoisted_11 = { class: "right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "数量", -1))
const _hoisted_13 = { class: "num-red" }
const _hoisted_14 = { class: "num-red" }
const _hoisted_15 = { class: "num-red" }
const _hoisted_16 = { class: "autoList__content" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " - ", -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "fl-row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "确认导出折扣卡数据嘛？", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftOutlined = _resolveComponent("LeftOutlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_add_card_modal = _resolveComponent("add-card-modal")!
  const _component_confirm_modal = _resolveComponent("confirm-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer autoList" }, {
    title: _withCtx(() => [
      _createVNode(_component_router_link, { to: "/discountCard/batchList" }, {
        default: _withCtx(() => [
          _createVNode(_component_LeftOutlined)
        ]),
        _: 1
      }),
      _createTextVNode(" 折扣卡批次详情 ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.batchId), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.enterpriseName), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.channelText(_ctx.detailInfo)), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(_ctx.detailInfo.activityName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", null, [
            _createElementVNode("div", null, _toDisplayString(_ctx.detailInfo.quantity) + " 张", 1),
            _createElementVNode("div", null, [
              _createTextVNode("已发放(未使用): "),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.detailInfo.waitConsumeTotal), 1),
              _createTextVNode(" 张")
            ]),
            _createElementVNode("div", null, [
              _createTextVNode("已消费: "),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.detailInfo.hasConsumeTotal), 1),
              _createTextVNode(" 张")
            ]),
            _createElementVNode("div", null, [
              _createTextVNode("已作废/过期: "),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.detailInfo.endTotal), 1),
              _createTextVNode(" 张")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_a_form, {
          class: "fl-clean autoList__filterForm",
          form: _ctx.filterParams,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "折扣卡ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.filterParams.discountCardId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams.discountCardId) = $event)),
                  class: "filterInput",
                  "allow-clear": "",
                  placeholder: "批次ID"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "分配员工" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.filterParams.allocationPerson,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.allocationPerson) = $event)),
                  class: "filterInput",
                  "allow-clear": "",
                  placeholder: "分配员工"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "消费订单" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.filterParams.orderCode,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.orderCode) = $event)),
                  class: "filterInput",
                  "allow-clear": "",
                  placeholder: "消费订单"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.filterParams.status,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterParams.status) = $event)),
                  style: {"width":"180px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("全部")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardStatusEnum, (objVal, objKey) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: objKey,
                        value: objKey
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(objVal), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "发放时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.filterParams.allocationTime,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterParams.allocationTime) = $event)),
                  format: "YYYY-MM-DD",
                  placeholder: ['起始时间', '结束时间']
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "消费时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.filterParams.orderTime,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterParams.orderTime) = $event)),
                  format: "YYYY-MM-DD",
                  placeholder: ['起始时间', '结束时间']
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "过期时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.filterParams.expireTime,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterParams.expireTime) = $event)),
                  format: "YYYY-MM-DD",
                  placeholder: ['起始时间', '结束时间']
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "作废时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.filterParams.cancelTime,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterParams.cancelTime) = $event)),
                  format: "YYYY-MM-DD",
                  placeholder: ['起始时间', '结束时间']
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  ghost: "",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onRefreshTable()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  style: {"margin-left":"10px"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onExport()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form"]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "id",
          "show-pagination": true,
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          "row-selection": _ctx.selectState,
          scroll: { x: true }
        }, {
          effectiveDays: _withCtx(({ record }) => [
            (record.fixedTermFlag===1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", null, _toDisplayString(record.effectiveStartDate), 1),
                  _hoisted_18,
                  _createElementVNode("div", null, _toDisplayString(record.effectiveEndDate), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(`发放后 ${record.effectiveDays} 天`), 1))
          ]),
          action: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_20, [
              (['WAIT_ALLOCATION'].includes(record.status))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (_ctx.onDistribute(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("分配")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (['WAIT_ALLOCATION','WAIT_CONSUME'].includes(record.status))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "link",
                    onClick: ($event: any) => (_ctx.onInvalid(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("作废")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["columns", "data", "row-selection"])
      ]),
      (_ctx.showModal)
        ? (_openBlock(), _createBlock(_component_add_card_modal, {
            key: 0,
            ref: "addCardRef",
            onClose: _ctx.closeModal
          }, null, 8, ["onClose"]))
        : _createCommentVNode("", true),
      (_ctx.showConfirmModal)
        ? (_openBlock(), _createBlock(_component_confirm_modal, {
            key: 1,
            "confirm-info": _ctx.confirmInfo,
            onClose: _ctx.closeConfirmModal
          }, null, 8, ["confirm-info", "onClose"]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        visible: _ctx.confirmVisible,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.confirmVisible) = $event)),
        title: "导出批次详情折扣卡",
        "confirm-loading": _ctx.exporting,
        "ok-text": "导出",
        onOk: _ctx.onConfirmExport
      }, {
        default: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      }, 8, ["visible", "confirm-loading", "onOk"])
    ]),
    _: 1
  }))
}